import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../domain/documents/Documents.css";
import "./WorkplaceRequiredModal.css";

/** @typedef {'default' | 'documents' | 'timesheets' | 'attendance' | 'salaryComponents' | 'payrollStructures' | 'users'} WorkplaceRequiredMessageKey */

const MESSAGE_KEYS = {
  default: "messageDefault",
  documents: "messageDocuments",
  timesheets: "messageTimesheets",
  attendance: "messageAttendance",
  salaryComponents: "messageSalaryComponents",
  payrollStructures: "messagePayrollStructures",
  users: "messageUsers",
};

/**
 * @param {{
 *   open: boolean;
 *   onClose: () => void;
 *   messageKey?: WorkplaceRequiredMessageKey;
 * }} props
 */
const WorkplaceRequiredModal = ({ open, onClose, messageKey = "default" }) => {
  const { t } = useTranslation();
  const history = useHistory();

  if (!open) return null;

  const msgKey = MESSAGE_KEYS[messageKey] || MESSAGE_KEYS.default;

  const goToWorkplaces = () => {
    onClose();
    history.push("/workplaces");
  };

  return (
    <div
      className="documents-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="workplace-required-dialog-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="documents-modal documents-modal--upload-single documents-modal--delete-confirm workplace-required-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="documents-modal-preview" style={{ borderRight: "none", background: "#fff" }}>
          <div className="documents-upload-modal-header">
            <div>
              <p className="documents-upload-modal-eyebrow">{t("app.workplaceRequired.eyebrow")}</p>
              <h2 className="documents-upload-modal-title" id="workplace-required-dialog-title">
                {t("app.workplaceRequired.title")}
              </h2>
            </div>
            <button
              type="button"
              className="btn btn-light documents-btn"
              aria-label={t("app.common.close")}
              onClick={onClose}
            >
              {t("app.common.close")}
            </button>
          </div>

          <div className="documents-modal-sheet documents-modal-sheet--upload documents-delete-confirm-body">
            <div className="documents-delete-confirm-summary">
              <div className="workplace-required-modal__icon-wrap" aria-hidden>
                <i className="bi bi-building" />
              </div>
              <div>
                <p className="workplace-required-modal__lead">{t(`app.workplaceRequired.${msgKey}`)}</p>
                <p className="workplace-required-modal__hint">{t("app.workplaceRequired.hint")}</p>
              </div>
            </div>

            <div className="documents-modal-actions documents-delete-confirm-actions workplace-required-modal__actions">
              <button type="button" className="btn btn-light documents-btn" onClick={onClose}>
                {t("app.workplaceRequired.dismiss")}
              </button>
              <button
                type="button"
                className="btn documents-btn documents-btn--primary-workplace"
                onClick={goToWorkplaces}
              >
                <i className="bi bi-building-add me-2" aria-hidden />
                {t("app.workplaceRequired.goToWorkplaces")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkplaceRequiredModal;
